import Route from '@ember/routing/route';

export default class LoginFailedRoute extends Route {}
